export default __webpack_public_path__ + "static/media/brand-image-12.5414cbdb.jpg";